// extracted by mini-css-extract-plugin
export default {"messageLength":"optionalMessage_messageLength__IvDPY"};